module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-photo-planning-75a4fb0321193c3947041d555499cf6a.png";